<template>
    <div class="applyState">
      <!-- <van-nav-bar
        title="取牌申请状态查询"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      /> -->
      <van-divider
      :style="{ color: '#1989fa', borderColor: '#1989fa', margin:0,height:'50px',fontSize:'16px',}"
    >
    取 牌 查 询
    </van-divider>
    <div class="dialog"></div>
    <van-form ref="ruleForm" :model="ruleForm"  style="opacity: .8;">
        <van-cell-group>
        <!-- <van-field 
        :value="ruleForm.idNo" 
        label="身份证号：" 
        placeholder="身份证号码" 
        :rules="idNoRules"
        readonly
        @touchstart.native.stop="showIdNoKeyboard" /> 
  
        <van-field  label="车牌号码：" v-model="ruleForm.plateNo" @blur="$refs.plate.submit()">
          <template #input>
            <plateNumber @func="getPlateNo" ref="plate" @plateType="getPlateType"></plateNumber>
          </template>
        </van-field>
        <van-field
        :value="ruleForm.verifyNo"
        label="图片验证码："
        placeholder="验证码"
        :rules="[{ required: true,}]"
        type="digit"
        maxlength="4"
        readonly
        @touchstart.native.stop="showPhoneNoKeyboard"
        >
        <template #button>
            <div  @click.stop="refreshCode">
            <sidentify :identify-code="identifyCode"/>
            </div>
        </template>
        </van-field> -->
        <!-- <van-row>
          <van-cell>身份证号码：</van-cell>
        </van-row>
        <van-row>
          <van-field 
        :value="ruleForm.idNo" 
        placeholder="点击输入身份证号码" 
        :rules="idNoRules"
        readonly
        @touchstart.native.stop="showIdNoKeyboard" /> 
        </van-row> -->
        <van-row>
            <van-cell class="titleStyle">业务受理点：</van-cell>
        </van-row>
        <van-row class="picker">
          <van-field
            readonly
            clickable
            :value="selectValue"
            placeholder="点击选择业务受理点"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
              show-toolbar
              title="下划查看更多服务站"
              :columns="stationOption"
              @cancel="showPicker = false"
              :visible-item-count = 9
              @confirm="onConfirm"
            />
          </van-popup>
        </van-row>
        <!-- <van-row>
          <van-col :span="8">
            <van-cell class="titleStyle">业务受理点：</van-cell>
          </van-col>
          <van-col :span="16" class="select">
            <van-dropdown-menu active-color="#1989fa">
              <van-dropdown-item v-model="selectValue" :options="stationOption" @change="selectChange(selectValue)"/>
            </van-dropdown-menu>
          </van-col>
        </van-row> -->
        <van-divider style="margin: 0;"/>
        <van-row>
          <van-cell class="titleStyle">车牌号码：</van-cell>
        </van-row>
        <van-divider style="margin: 0;"/>
        <van-row>
            <plateNumber @func="getPlateNo" ref="plate" @plateType="getPlateType" style="margin: 10px auto;" />
        </van-row>
        <!-- <van-field
        :value="ruleForm.verifyNo"
        label="验证码："
        placeholder="验证码"
        :rules="[{ required: true,}]"
        type="digit"
        maxlength="4"
        readonly
        @touchstart.native.stop="showPhoneNoKeyboard"
        >
        <template #button>
            <div  @click.stop="refreshCode">
            <sidentify :identify-code="identifyCode"/>
            </div>
        </template>
        </van-field> -->
      </van-cell-group>
      <div>
      <div style="margin: 16px;">
        <van-button @click="queryApplyState" round block type="info">查 询</van-button>
        <van-button  @click="goBack" round style="width: 98%; margin-top: 2%;margin-left: 0;">返回首页</van-button>
      </div>
    </div>
    </van-form>
    <!-- 展示数据 -->
    <van-overlay :show="showData" @click="showData=false">
      <div class="wrapper" @click.stop>
        <div class="statePoolBlock">
          <div class="title">
            <span>取牌信息
              <!-- <van-icon name="close" class="cancel" @click="showData = false"/> -->
            </span>
          </div>
          <van-cell :title="'身份证号：'">{{ showList.idNo }}</van-cell>
          <van-cell :title="'车牌号码：' ">{{ showList.plateNo }}</van-cell>
          <van-cell :title="'取牌地点：' ">{{ showList.getStation}}</van-cell>
          <van-cell :title="'登记时间：' ">{{ showList.createTime | formatTime }}</van-cell>
          <van-cell :title="'状态：' " class="state">
            <template #default>
              <span v-html="applyStateText"></span>
            </template>
          </van-cell>
          <!-- <van-cell :title="'状态：' " style="color: red;" :value="applyStateText"></van-cell> -->
          <div style="margin: 16px;">
            <van-button round block type="info" @click="closeOverlay">
              确定</van-button>
              <van-button round block  @click="navigateToSend" style="margin-top: 4%;background-color: #18AE66;color: white;">我 要 邮 寄</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 身份证号键盘 -->
    <van-number-keyboard
      :show="idNoKeyboardShow"
      extra-key="X"
      title="身份证号码"
      maxlength="18"
      close-button-text="完成"
      @blur="blurIdNo"
      v-model="ruleForm.idNo"
    />
    <!-- 验证码键盘 -->
    <van-number-keyboard
      extra-key="."
      title="验证码"
      close-button-text="完成"
      maxlength="4"
      v-model="ruleForm.verifyNo"
      :show="verifyNoKeyboardShow"
      @blur="blurVerifyNo"
    />
  
  </div>
  </template>
  <script>
  import Sidentify from '../components/identify.vue'
  import{QueryApply,QueryStationDic,ApplyEmsUrl} from '../my_js/HttpRequest'
  import { Notify,Dialog} from 'vant';
  import PlateNumber from '../components/plateNo.vue'
  import idNoKeyBoard from '../components/keyboard.vue'
  import {formatTime,getNowTime,formatDateTime,formatBeginTime,formatEndTime} from '@/utils/date.js'
  import {maskIdCard} from '@/utils/idNo.js'
  import store from '@/store/index.js'
  export default{
    components:{PlateNumber,idNoKeyBoard,Sidentify},
    filters:{
    formatTime:function(inputTime){
      return formatTime(inputTime)
    },
    },
    created(){
      this.queryStationDic()
    },
    data(){
      return{
        identifyCode:'',//图片验证码
        identifyCodes:'0123456789',//随机验证码范围
        idNoKeyboardShow:false,//身份证键盘
        verifyNoKeyboardShow:false,//验证码键盘
        dialogVisible:false,//显示信息确认对话框
        ruleForm: {
            // idNo: '',//身份证号码
            plateNo: '',//车牌号
            plateType:null,//车牌类型
            // verifyNo:'',//验证码
            applyStationCode:'',//业务受理点
            dateBegin:null,//开始时间
            dateEnd:null,//结束时间
        },
        showList:[],//查询到的数据
        showData:false,
        applyStateText:null,//车牌状态
        // selectValue:0,//下拉框默认选择
        selectValue:'',//下拉框默认选择
        getStationInfo:'',//用户选择的号牌领取点信息
        showPicker: false,//选项是否显示
        stationOption:[],//下拉框选项
        stationDic:[],//服务站字典信息
        // 身份证验证
        idNoRules:[{ required:true,message:'请输入身份证号码', trigger:'change'},
        { pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号码格式不正确', trigger: 'blur' },],
         // 车牌号验证
         plateNoRules:[{ required:true, trigger: 'change' ,message:'请输入车牌号码'}],
         // 验证码验证
         verifyNoRules:[{required:true,message:'请输入4位验证码',pattern: /^\d{4}$/},
          {pattern: /^\d{4}$/,message: '请输入4位数验证码',trigger: 'blur'}]
      }
    },
    mounted(){
        // 组件挂载完毕刷新验证码
        this.refreshCode()

        const end = new Date()
        const start = new Date()
        end.setTime(start.getTime() - 3600 * 1000 * 24 * 7)//默认查询7天时间
        const data = formatDateTime(end)
        console.log(data);
        this.ruleForm.dateBegin = data
        this.ruleForm.dateEnd = getNowTime()//当天时间

        this.$refs.plate.resetData()//清除车牌号
    },
    methods:{
      // 返回
      goBack(){
        console.log('返回首页');
        store.commit('setStation', [])
        this.$router.push('/home')
      },
      showIdNoKeyboard() {
        this.idNoKeyboardShow = true;
        this.verifyNoKeyboardShow = false;
        this.$refs.plate.hideKeyboard()
      },
      blurIdNo(){
        // 验证身份证号
        const reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
        const reg1 = new RegExp(/^[A-Z]\d{7,11}$/)
        if(!reg1.test(this.ruleForm.idNo) && !reg.test(this.ruleForm.idNo)){
          Notify({type:'warning',message:'请输入正确的身份证号'})
          // return
        }
        this.idNoKeyboardShow = false
      },
      showPhoneNoKeyboard() {
        this.idNoKeyboardShow = false;
        this.verifyNoKeyboardShow = true;
        this.$refs.plate.hideKeyboard()
        this.focusVerifyNo()
      },
      // showVerifyNoKeyboard() {
      //   // 首先确保隐藏其他可能显示的字段
      //   this.idNoKeyboardShow = false;
      //   this.verifyNoKeyboardShow = true; // 显示验证码字段
      //   this.focusVerifyNo()
      // },
      // 验证验证码   
      blurVerifyNo(){
        //重置
      this.$nextTick(() => {
      const container = document.querySelector('.applyState');
      if (container) {
          container.style.paddingBottom = '0px';
          console.log('Container found and padding set');
          setTimeout(() => {
              console.log('Scrolling to bottom');
              container.scrollTop = container.scrollHeight;
              console.log('Scroll top set to:', container.scrollTop);
          }, 100);
      } else {
          console.error('Container not found');
      }
      });
        const reg = /^\d{4}$/
        if(!reg.test(this.ruleForm.verifyNo)){
            Notify({type:'warning',message:'请输入4位验证码'})
        }
        this.verifyNoKeyboardShow = false
      },
      focusVerifyNo(){
        this.$nextTick(() => {
        const container = document.querySelector('.applyState');
        console.log('container',container);
        if (container) {
            container.style.paddingBottom = '280px';
            console.log('Container found and padding set');
            setTimeout(() => {
                console.log('Scrolling to bottom');
                container.scrollTo(0, container.scrollHeight);
                console.log('Scroll top set to:', container.scrollTop);
            }, 100);
        } else {
            console.error('Container not found');
          }
      });
        
      },
       // 获取车牌号
      getPlateNo(data){
          this.ruleForm.plateNo = data
      },
      // 获取车牌类型
      getPlateType(val){
        console.log('车牌类型：',val);
        this.ruleForm.plateType = val
        console.log(this.ruleForm.plateType);
      },
      // 查询
      queryApplyState() {
        let _this = this;
        console.log('表单数据：', _this.ruleForm);

        // _this.$refs.plate.hideKeyboard()
        if(this.selectValue == '' || this.selectValue == null){
          return Dialog.alert({
              title: '提 示',
              message: '<span style="color:#ff9933">请选择业务受理点</span>',
              confirmButtonColor:'#1989fa',
              theme: 'round-button',
              width:'300px',
            }).then(() => {
              
            });
        }
        _this.$refs.plate.hideKeyboard()
        _this.$refs.ruleForm.validate()
            .then(valid => {
                  // 表单验证成功
                  console.log('验证通过');
                  // 检验验证码是否一致
                //   if(this.ruleForm.verifyNo != this.identifyCode){
                //   Notify({type:'warning',message:'图形验证码不一致'})
                //   return
                // }
                if((_this.ruleForm.plateType == 0 && _this.ruleForm.plateNo.length < 7)||(_this.ruleForm.plateType == 1 && _this.ruleForm.plateNo.length < 8)){
                  Notify({type:'warning',message:'请填写正确的车牌号后再查询'})
                  return
                }
                const queryArray = {
                  // applyStationCode:this.ruleForm.applyStationCode,
                  applyStationCode:'',
                  plateNo:this.ruleForm.plateNo,
                  dateBegin:formatBeginTime(this.ruleForm.dateBegin),
                  dateEnd:formatEndTime(this.ruleForm.dateEnd)
                }
                console.log('queryArray',queryArray);
                console.log(JSON.stringify(queryArray));

                QueryApply(queryArray).then(res => {
                  // debugger
                  console.log(res);
                  if(res.data.length == 0){
                    // Notify({type:'warning',message:'查询不到您的车牌自取申请数据，请回到首页进行车牌自取申请登记',duration:5000})
                    Dialog.confirm({
                      title: '提示',
                      message: '查询不到您的车牌自取申请数据，可点击下方“登记信息”按钮进行信息登记',
                      confirmButtonText:'登记信息',
                      getContainer:'.dialog',
                    })
                      .then(() => {
                        // on confirm
                        // debugger
                        console.log('点击了确定');
                        this.$refs.plate.resetData(1)//保存车牌号
                        // this.$router.push('/certMessage')
                        this.$router.push('/certMessage')
                      })
                      .catch(() => {
                        // on cancel
                        console.log('点击了取消');
                        this.closeOverlay()   
                      });
                    // this.closeOverlay()
                    // return
                  }else{
                    // this.showList = this.findMaxTimeData(res.data)
                    // // 身份证号加密 
                    // this.showList.idNo =maskIdCard(this.showList.idNo)
                    // console.log('this.showList',this.showList);
                    // if(this.showList.state == 0){
                    //   if(this.showList.boxCode == '' || this.showList.boxCode == null){
                    //     this.applyStateText = '车牌未制作完成，请稍后再查询'
                    //   }else if((this.showList.boxCode != '' || this.showList.boxCode != null) && this.showList.boxState == 2){
                    //     this.applyStateText = '车牌已存入，可凭身份证自取'
                    //   }
                    // }else if(this.showList.state == 1){
                    //   this.applyStateText = '车牌自取已完成'
                    // }else if(this.showList.state > 1){
                    //   // Notify({type:'warning',message:'查询不到您的车牌自取申请数据，请回到首页进行车牌自取申请登记',duration:5000})
                    //   Dialog.confirm({
                    //   title: '提示',
                    //   message: '查询不到您的车牌自取申请数据，可点击下方“登记信息”按钮进行信息登记',
                    //   confirmButtonText:'登记信息',
                    //   getContainer:'.dialog'
                    // })
                    //   .then(() => {
                    //     // on confirm
                    //     debugger
                    //     console.log('点击了确定');
                    //     this.$refs.plate.resetData(1)//保存车牌号
                    //     // this.$router.push('/certMessage')
                    //     this.$router.push('/station')
                    //   })
                    //   .catch(() => {
                    //     // on cancel
                    //     console.log('点击了取消');
                    //     this.closeOverlay()
                    //   });
                    //   // this.closeOverlay()
                    //   // return
                    // }
                    // this.showData = true

                    this.showList = this.findMaxTimeData(res.data)
                    // 身份证号加密 
                    // this.showList.idNo =maskIdCard(this.showList.idNo)
                    console.log('this.showList',this.showList);
                     // 号牌领取点信息
                    this.getStationInfo = this.stationDic.filter(item => item.code === this.showList.getStationCode)
                    this.getStationInfo = this.getStationInfo[0]
                    console.log('getStationInfo',this.getStationInfo);
                    this.showList.getStation = this.getStationInfo.name
                    // return
                    // debugger
                    if(this.showList.applyStationCode != this.ruleForm.applyStationCode){
                      return Dialog.alert({
                        title: '提 示',
                        message: '<span style="color:#ff9933">您选择的业务受理点与登记时所选的业务受理点不符，请确认后再查询</span>',
                        confirmButtonColor:'#1989fa',
                        theme: 'round-button',
                        width:'300px',
                        messageAlign:'left',
                      }).then(() => {
                        
                      });
                    }else{
                      if(this.getStationInfo.selfGetStation == 1){
                        this.showList = this.findMaxTimeData(res.data)
                        // 身份证号加密 
                        // this.showList.idNo =maskIdCard(this.showList.idNo)
                        console.log('this.showList',this.showList);
                        // debugger
                        if(this.showList.state == 0){
                          if(this.showList.boxCode == '' || this.showList.boxCode == null){
                            this.applyStateText = '车牌未制作完成，请稍后再查询'
                          }else if((this.showList.boxCode != '' || this.showList.boxCode != null) && (this.showList.boxState==0 || this.showList.boxState ==1) ){
                            this.applyStateText = '车牌正在制作中，请稍后再查询'
                          }
                          else if((this.showList.boxCode != '' || this.showList.boxCode != null) && this.showList.boxState == 2){
                            // this.applyStateText = '车牌已存入，可凭<span style="color:#1989fa"> 身份证 </span>与<span style="color:#1989fa">《领牌凭证》</span>自取'
                            this.applyStateText = '车牌已存入，可凭<span style="color:#1989fa"> 领牌人身份证 </span> 自取'
                          }
                        }else if(this.showList.state == 1){
                          this.applyStateText = '车牌自取已完成'
                        }else if(this.showList.state > 1){
                          Dialog.confirm({
                            title: '提示',
                            message: '查询不到您的车牌自取申请数据，可点击下方“登记信息”按钮进行信息登记',
                            confirmButtonText:'登记信息',
                            getContainer:'.dialog'
                          })
                          .then(() => {
                            // on confirm
                            console.log('点击了确定');
                            this.$refs.plate.resetData(1)//保存车牌号
                            this.$router.push('/certMessage')
                          })
                          .catch(() => {
                            // on cancel
                            console.log('点击了取消');
                            this.closeOverlay()
                          });
                        }
                        this.showData = true
                        }else if(this.getStationInfo.selfGetStation == 0){
                          // debugger
                          if(this.showList.state == 0 || this.showList.state == 1){
                            console.log('制作中');
                            this.applyStateText = '车牌正在制作中，请稍后再查询'
                          }else if(this.showList.state == 2){
                            console.log('去服务站取');
                            this.applyStateText = '车牌已到服务站，可以前往领取'
                          }
                          this.showData = true
                        }
                    }

                  }
                })
  
            })
            .catch(error => {
                console.log('验证不通过');
                console.error('Validation failed:', error);
            });
        },
        // 获取车牌类型
        getPlateType(val){
          console.log('车牌类型：',val);
          this.ruleForm.plateType = val
          console.log(this.ruleForm.plateType);
        },
        // 验证码点击刷新
        refreshCode(){
        this.identifyCode = ''
        this.makeCode(this.identifyCodes,4)
        },
        // 随机数
        randomNum(min,max){
        max = max + 1
        return Math.floor(Math.random() * (max - min) + min)
        },
        // 生成随机验证码
        makeCode(data,len){
        for(let i=0;i < len;i++){
            this.identifyCode += data[this.randomNum(0,data.length - 1)]
        }
        console.log('随机验证码：',this.identifyCode);
        },
        // 筛选数据
        findMaxTimeData(dataArray) {
          if (dataArray.length === 0) {
          return null; // 如果数组为空，返回null或者适当的默认值
        }
          // 返回时间最大的两条数据
         dataArray.sort((a,b) => new Date(b.createTime) - new Date(a.createTime))
          return dataArray[0];
        },
        // 关闭弹窗
        closeOverlay(){
        //   this.ruleForm = {
        //     idNo: '',//身份证号码
        //     plateNo: '',//车牌号
        //     verifyNo:'',//验证码
        //     dateBegin:null,//开始时间
        //     dateEnd:null,//结束时间
        // },
          this.ruleForm.idNo = '',
          this.ruleForm.plateNo = '',
          this.ruleForm.verifyNo = ''
          const end = new Date()
          const start = new Date()
          end.setTime(start.getTime() - 3600 * 1000 * 24 * 30)//默认查询30天时间
          const data = formatDateTime(end)
          console.log(data);
          this.ruleForm.dateBegin = data
          this.ruleForm.dateEnd = getNowTime()//当天时间

          this.$refs.plate.resetData()//清除车牌号
          // 刷新验证码
          this.refreshCode()
          this.showData = false
        },
        // 获取服务站信息
        queryStationDic(){
          // this.stationOption.push({text:'请选择服务站',value:0})
          QueryStationDic().then(res => {
            console.log(res);
            this.stationDic = res.data
            this.stationDic.forEach(element => {
              this.stationOption.push({text:element.name,value:element.code,getStation:element.getStation})
            });
            console.log('服务站信息:',this.stationOption);
            // this.selectValue = this.stationOption[0].value // 默认选择
            // this.selectChange(this.selectValue)
          })
        },
        // 服务站选项发生变化
        onConfirm(value) {
          console.log('用户选择的业务受理点',value);
          this.selectValue = value.text;
          this.showPicker = false;
          this.ruleForm.applyStationCode = value.value
          store.commit('setStation', value)
        },
        // 我要邮寄
        navigateToSend(){
          // // 要传递的参数 userId
          // const customerId = '12345';
          // const licenseNumber = this.showList.plateNo;
          // const receiveName = '张三';
          // const receivePhone = this.showList.phoneNo;

          // // 将参数添加到URL查询字符串中
          // // const urlWithParams = `http://baidu.com?customerId=${customerId}`+`licenseNumber=${licenseNumber}`+`receiveName=${receiveName}`+`receivePhone=${receivePhone}`;
          // const urlWithParams = `http://baidu.com?customerId=${customerId}`+`licenseNumber=${licenseNumber}`;
          // // 使用window.location.href进行页面跳转
          // window.location.href = urlWithParams;

          const sendArray = {
            id:this.showList.id,
            plateNo:this.showList.plateNo,
            phoneNo:this.showList.phoneNo,
            dateBegin:formatBeginTime(this.ruleForm.dateBegin),
            dateEnd:formatEndTime(this.ruleForm.dateEnd)
          }
          console.log(sendArray);
          
          ApplyEmsUrl(sendArray).then(res => {
            console.log(res);
            const urlWithParams = res.msg
            console.log(urlWithParams);
            // return
            // 页面跳转
            window.location.href = urlWithParams 
          })

        }
    }
  }
  </script>
  <style lang="scss">
  .applyState{
    width: 100%;
    height: 100%;
    overflow-y: auto; /* 尝试使用 auto */
    background-color: #F7F8FA;
    .van-number-keyboard{
      background-color: #F2F3F5;
      padding: 0;
    }
    .van-key{
      width: 100%;
    }
    .van-cell__value{
      text-align: left;
    }
    .state{
      font-weight: bold;
      color: #EE8800;
      .van-cell__value{
      color: #EE8800;
      white-space: normal;
    }
    }
    .van-button--small{
      padding: 0 10px;
    }
    .van-nav-bar__left{
    left: 0;
    }
    .van-nav-bar .van-icon{
      color: #0283ef;
    }
    .van-nav-bar__text{
      color: #0283ef;
    }
    .wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .title{
      margin-top: 3%;
      .cancel{
        float: right;
        margin-right: 3%;
        font-size: 28px;
      }
    }
    .statePoolBlock{
      width: 95%;
      // height: 50%;
      border-radius: 8px;
      background-color: #fff;
      .van-cell__value{
        text-align: left;
      }
    }
    .dialog{
      .van-dialog__confirm{
        background-color: #1989fa;
        color: #fff;
      }
      .van-dialog__cancel{
        background-color: #f6f7f8;
        color: #000;
        border: #e6e8ec 1px solid;
        margin-right: 3px;
      }
      .van-dialog__footer{
        padding: 5px 5px;
      }
      .van-dialog__header{
        color: #000;
      }
      .van-dialog__message--has-title{
        color: #ff9900;
        text-align: left;
      }
    }
    .titleStyle{
      .van-cell__value--alone{
        color: #1989fa;
        font-weight: bold;
      }
    }
    .select{
      // border: red 1px solid;
      .van-dropdown-menu{
        margin: 2%;
        border: gainsboro 1px solid;
      }
    }
   .picker{
    .van-picker__title{
      color: #fa8f04;
      font-weight: bold;
    }
   }
  }
  .van-dialog__confirm {
    background-color: #0094ff; /* 确认按钮背景色 */
    color: #fff; /* 确认按钮字体颜色 */
  }
  </style>